module.exports = __webpack_public_path__ + "static/media/settings-restaurant.58cc0700.svg";